import { TwoElementResizablePage } from "layouts";

interface Props {
  defaultLeftWidth?: number;
  leftNode: React.ReactNode;
  rightNode: React.ReactNode;
  rightExpanded?: boolean;
  onLeftColumnClick?: VoidFunction;
}

export function HorizontalDashboard(props: Props) {
  const {
    defaultLeftWidth = 65,
    leftNode,
    rightNode,
    rightExpanded,
    onLeftColumnClick,
  } = props;
  return (
    <TwoElementResizablePage
      minLeftWidth={rightExpanded ? 30 : 50}
      maxLeftWidth={80}
      minRightWidth={30}
      maxRightWidth={80}
      defaultLeftWidth={defaultLeftWidth}
      leftWidthOverride={rightExpanded ? 30 : undefined}
      leftChildren={leftNode}
      rightChildren={rightNode}
      onLeftColumnClick={onLeftColumnClick}
    />
  );
}
